import React from 'react'
import NavigationBar from './NavigationBar'
import Footer from './Footer'
import { Container } from 'react-bootstrap'

export default function AccountDeletion() {
    return (
        <div>
            <NavigationBar />

            <Container>
                <h1 style={{ marginTop: "3rem" }}>Account Deletion</h1>
                <p>
                    Users may delete their account at any time through the Delete Account option available within the app settings. Once the deletion request is confirmed, the user's account and associated personal information will be permanently removed from our systems.
                </p>
                <p>
                    Please note that certain information may be retained for a limited period where required by applicable laws, regulatory obligations, fraud prevention, dispute resolution, or other legitimate business purposes. Any retained data will be handled in accordance with our Privacy Policy and applicable data protection laws.
                </p>
                <p>
                    For any assistance regarding account deletion, users may contact our support team through the app or official support channels.
                </p>
            </Container>


            <Footer />
        </div>
    )
}
